import api from '@/plugins/axios';

/** How many entries a contest has so far. */
export const CountEntries = async (contestId: string): Promise<number> => {
  const { data } = await api.get<{ count: number }>(`/contest-entries/${contestId}/count`);
  return data.count;
}

/** The entries of a contest as a CSV file, ranked by the API with the winner first. */
export const DownloadEntries = async (contestId: string, tiebreaker: string, answer: string): Promise<Blob> => {
  const { data } = await api.get<Blob>(`/contest-entries/${contestId}.csv`, { params: { tiebreaker, answer }, responseType: 'blob' });
  return data;
}
